import React from 'react';

interface ButtonProps {
    onClick: () => void;
    label: string;
}

export function Button({ onClick, label }: ButtonProps) {
    return (
        <div className="relative flex-grow">
            <button
                onClick={onClick}
                className={`absolute ml-12 mt-12 rounded-lg transition-all duration-200 group relative`}
                title={label}
            >
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-s font-medium text-white bg-indigo-300 rounded-md group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    {label}
                </span>
            </button>
        </div>
        
    );
}